import { call } from "redux-saga/effects"
import {
  LOGIN_USER,
  LOGIN_OTP,
  LOGIN_SUCCESS,
  LOGOUT_USER,
  GET_CURRENT_USER,
  GET_CURRENT_USER_SUCCESS,
  GET_CURRENT_USER_FAIL,
  LOGOUT_USER_SUCCESS,
  API_ERROR,
  SOCIAL_LOGIN_REQUEST, SOCIAL_LOGIN_SUCCESS, SOCIAL_LOGIN_FAIL,
  GET_LANGUAGES,
  GET_LANGUAGES_SUCCESS,
  GET_LANGUAGES_FAIL,
  LOGIN_USER_FAIL,
  GET_ACCES_TOKEN_INFO,GET_ACCES_INFO_SUCCESSFULL,GET_ACCES_INFO_FAILED,
  CHANGE_PASSWORD, CHANGE_PASSWORD_SUCCESS,CHANGE_PASSWORD_FAIL,
  EDIT_PROFILE, EDIT_PROFILE_SUCCESS,EDIT_PROFILE_FAIL,
  SET_PASSWORD, SET_PASSWORD_FAIL, SET_PASSWORD_SUCCESS
} from "./actionTypes"



export const loginUser = (user, callback) => {
  return {
    type: LOGIN_USER,
    payload: { user, callback },
  }
}

export const logInUserFailed = (user, callback) => {
  return {
    type: LOGIN_USER_FAIL,
    payload: { user, callback },
  }
}

export const loginWithOtp = (user, navigate) => {
  return {
    type: LOGIN_OTP,
    payload: { user, navigate },
  }
}

export const loginSuccess = user => {
  return {
    type: LOGIN_SUCCESS,
    payload: user,
  }
}

export const logoutUser = (history, role) => {
  return {
    type: LOGOUT_USER,
    payload: { history, role },
  }
}

export const currentUser = () => {
  return {
    type: GET_CURRENT_USER,
  }
}

export const currentUserSuccess = user => {
  return {
    type: GET_CURRENT_USER_SUCCESS,
    payload: user,
  }
}

export const currentUserFail = error => {
  return {
    type: GET_CURRENT_USER_FAIL,
    payload: error,
  }
}

export const logoutUserSuccess = () => {
  return {
    type: LOGOUT_USER_SUCCESS,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: API_ERROR,
    payload: error,
  }
}

export const getLanguages = () => ({
  type: GET_LANGUAGES,
})

export const getLanguagesSuccess = data => ({
  type: GET_LANGUAGES_SUCCESS,
  payload: data,
})

export const getLanguagesFail = error => ({
  type: GET_LANGUAGES_FAIL,
  payload: error,
})


export const socialLoginRequest = (user, callback) => {
  return {
    type: SOCIAL_LOGIN_REQUEST,
    payload: { user, callback },
  }
}
export const socialLoginSuccess = (data) => {
  return {
    type: SOCIAL_LOGIN_SUCCESS,
    payload: data,
  }
}
export const socialLoginFail = (error) => {
  return {
    type: SOCIAL_LOGIN_FAIL,
    payload: error,
  }
}


export const getAccessToken = (data, callback) => {
  return {
    type: GET_ACCES_TOKEN_INFO,
    payload: { data, callback },
  }
}

export const accessTokenSuccess = data => {
  return {
    type: GET_ACCES_INFO_SUCCESSFULL,
    payload: data,
  }
}

export const accessTokenFailed = data => {
  return {
    type: GET_ACCES_INFO_FAILED,
    payload: data,
  }
}


export const changePassword = (data, callback) => {
  return {
    type: CHANGE_PASSWORD,
    payload: { data, callback },
  }
}
export const changePasswordSuccess = (data) => {
  return {
    type: CHANGE_PASSWORD_SUCCESS,
    payload: data,
  }
}
export const changePasswordFail = (error) => {
  return {
    type: CHANGE_PASSWORD_FAIL,
    payload: error,
  }
}


export const setPassword = (data, callback) => {
  return {
    type: SET_PASSWORD,
    payload: { data, callback },
  }
}
export const setPasswordSuccess = (data) => {
  return {
    type: SET_PASSWORD_SUCCESS,
    payload: data,
  }
}
export const setPasswordFail = (error) => {
  return {
    type: SET_PASSWORD_FAIL,
    payload: error,
  }
}



export const editProfile = (data, callback) => {
  return {
    type: EDIT_PROFILE,
    payload: { data, callback },
  }
}
export const editProfileSuccess = (data) => {
  return {
    type: EDIT_PROFILE_SUCCESS,
    payload: data,
  }
}
export const editProfileFail = (error) => {
  return {
    type: EDIT_PROFILE_FAIL,
    payload: error,
  }
}
